import React, { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  action?: ReactNode;
}

export const EmptyState: React.FC<Props> = ({ title, description, action }) => (
  <div
    style={{
      padding: '56px 24px',
      textAlign: 'center',
      color: 'var(--text-muted)',
    }}
  >
    <div
      style={{
        fontSize: 16,
        fontWeight: 600,
        color: 'var(--text-primary)',
        marginBottom: 6,
      }}
    >
      {title}
    </div>
    {description ? (
      <div style={{ fontSize: 14, marginBottom: 16 }}>{description}</div>
    ) : null}
    {action ? <div>{action}</div> : null}
  </div>
);
